import { api } from '@/shared/redux/api/_generated/api/billing-api.generated';

export const billingApi = api.enhanceEndpoints({
  addTagTypes: ['TenantSubscription'],
  endpoints: {
    ReadTenantSubscription: {
      providesTags: [{ type: 'TenantSubscription', id: 'SUBSCRIPTION' }],
    },
    ReadTenantScheduledSubscriptionChanges: {
      providesTags: [{ type: 'TenantSubscription', id: 'SUBSCRIPTION' }],
    },
    SwitchTenantPlan: {
      invalidatesTags: ['TenantSubscription'],
    },
    UpdateTenantSubscription: {
      invalidatesTags: ['TenantSubscription'],
    },
    RevokeSubscriptionChange: {
      invalidatesTags: ['TenantSubscription'],
    },
    CancelSubscription: {
      invalidatesTags: ['TenantSubscription'],
    },
    CreateSubscription: {
      invalidatesTags: ['TenantSubscription'],
    },
    HandleTermsAndConditionsAcceptedForBilling: {
      invalidatesTags: ['TenantSubscription'],
    },
    ReadTenantFeatureUsageStats: {
      keepUnusedDataFor: 0,
    },
    ReadTenantEntitlementUsageStats: {
      keepUnusedDataFor: 0,
    },
    ReadTenantSubscriptionTermUsage: {
      keepUnusedDataFor: 0,
    },
  },
});

export const {
  useReadResalePlansQuery,
  useReadSubscriptionStatusQuery,
  useReadTenantSubscriptionQuery,
  useSwitchTenantPlanMutation,
  useUpdateTenantSubscriptionMutation,
  useReadTenantScheduledSubscriptionChangesQuery,
  useRevokeSubscriptionChangeMutation,
  useCancelSubscriptionMutation,
  useCreateSubscriptionMutation,
  useReadTenantFeatureUsageStatsQuery,
  useReadTenantEntitlementUsageStatsQuery,
  useReadTenantSubscriptionTermUsageQuery,
  useHandleTermsAndConditionsAcceptedForBillingMutation,
} = billingApi;
